const formCallbacks = (fieldConfig) => {
  if (!fieldConfig.callback) {
    return fieldConfig;
  }
  const callbacks = {
    createDestinationHierarchy: () => {
      let {options} = fieldConfig;
      // Sort values by label name.
      options.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        return +1;
      });

      // Remove parents from child string.
      options.map((option) => {
        const splitValue = option.label.split(' > ');
        const length = splitValue.length;
        option.label = length > 1 ? `- ${splitValue[length - 1]}` : <b>{splitValue[length - 1]}</b>;
        return option.bold;
      });

      return fieldConfig;
    },
    sortTerms: () => {
      let {options} = fieldConfig;
      const sort = ['spring', 'fall', 'summer', 'academic year', 'calendar year', 'january term'];

      options.forEach((item) => {
        const value = item.value.toLowerCase()
        if (!sort.includes(value)) {
          sort.push(value);
        }
      })
      fieldConfig.options = options.sort((a, b) => {
        const aValue = a.value.toLowerCase();
        const bValue = b.value.toLowerCase();

        return sort.indexOf(aValue) - sort.indexOf(bValue);
      });

      return fieldConfig;
    },
  };

  return callbacks[fieldConfig.callback]();
};

export default formCallbacks;
